"use client";

import { Checkbox } from "@/components/ui/checkbox";
import {
  setHolidayFilters,
  useHolidayFilter,
} from "@/feature/holiday/search/state/extract-holiday-filter-slice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { HolidayAccordion } from "./holiday-accordion";

export function HolidayTypeFilter() {
  const dispatch = useAppDispatch();
  const { selectedOption, defaultOption } = useAppSelector(useHolidayFilter);
  const types = defaultOption.holidayTypes;

  if (!types.length) {
    return null;
  }

  return (
    <HolidayAccordion value="holiday_type" label="Holiday Type">
      <div className="space-y-2">
        {types.map((type) => (
          <label key={type} className="flex items-center gap-2 text-sm">
            <Checkbox
              checked={selectedOption.holidayTypes.includes(type)}
              onCheckedChange={(checked) => {
                if (checked === "indeterminate") return;

                const next = selectedOption.holidayTypes.includes(type)
                  ? selectedOption.holidayTypes.filter((item) => item !== type)
                  : [...selectedOption.holidayTypes, type];
                dispatch(setHolidayFilters({ holidayTypes: next }));
              }}
            />
            <span>{type}</span>
          </label>
        ))}
      </div>
    </HolidayAccordion>
  );
}

